import clsx from 'clsx';
import { CalendarIcon } from '../icons/calendar';

export const DateInput = (ps: {
  value: number | string;
  onChange(v: number | string): void;
  label?: string;
  compact?: boolean;
}) => {
  const date = new Date(ps.value);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  const input_classes = clsx(
    '[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none rounded-lg border-2 text-black text-center outline-none',
    ps.compact ? 'p-1' : 'p-2',
  );

  return (
    <div className={clsx('flex items-start', ps.compact ? 'gap-4' : 'gap-8')}>
      <div>
        {ps.label && (
          <span className="text-sm text-neutral-500">Data {ps.label}</span>
        )}
        <div
          className={clsx(
            'flex items-center',
            ps.label && 'mt-1',
            ps.compact ? 'gap-1' : 'gap-3',
          )}>
          <input
            className={clsx(input_classes, 'w-11')}
            type="number"
            value={day}
            onChange={(e) =>
              ps.onChange(new Date(ps.value).setDate(+e.target.value))
            }
          />
          /
          <input
            className={clsx(input_classes, 'w-11')}
            type="number"
            value={month}
            onChange={(e) =>
              ps.onChange(new Date(ps.value).setMonth(+e.target.value - 1))
            }
          />
          /
          <input
            className={clsx(input_classes, 'w-16')}
            type="number"
            value={year}
            onChange={(e) =>
              ps.onChange(new Date(ps.value).setFullYear(+e.target.value))
            }
          />
          {!ps.compact && <CalendarIcon className="h-6 w-6 fill-neutral-500" />}
        </div>
      </div>
      <div>
        {ps.label && (
          <span className="text-sm text-neutral-500">Orario {ps.label}</span>
        )}
        <div
          className={clsx(
            'flex items-center',
            ps.label && 'mt-1',
            ps.compact ? 'gap-1' : 'gap-3',
          )}>
          {ps.compact && <span className="mr-1 text-neutral-400">Ore</span>}
          <input
            className={clsx(input_classes, 'w-11')}
            type="number"
            value={hours}
            onChange={(e) =>
              ps.onChange(new Date(ps.value).setHours(+e.target.value))
            }
          />
          :
          <input
            className={clsx(input_classes, 'w-11')}
            type="number"
            value={minutes}
            onChange={(e) =>
              ps.onChange(new Date(ps.value).setMinutes(+e.target.value))
            }
          />
        </div>
      </div>
    </div>
  );
};
